export default [
  require("/home/runner/work/medzuslovjansky.github.io/medzuslovjansky.github.io/node_modules/infima/dist/css/default/default.css"),
  require("/home/runner/work/medzuslovjansky.github.io/medzuslovjansky.github.io/node_modules/@docusaurus/theme-classic/lib/prism-include-languages"),
  require("/home/runner/work/medzuslovjansky.github.io/medzuslovjansky.github.io/node_modules/@docusaurus/theme-classic/lib/nprogress"),
  require("/home/runner/work/medzuslovjansky.github.io/medzuslovjansky.github.io/src/css/custom.scss"),
];
